export const RETURN_TO_PROVISION = 'RETURN_TO_PROVISION';
export const FETCH_RTP_DATA_SUCCESS = 'FETCH_RTP_DATA_SUCCESS';
export const FETCH_RTP_DATA_FAILURE = 'FETCH_RTP_DATA_FAILURE';

export const UPLOAD_RTP_DATA = 'UPLOAD_RTP_DATA';
export const UPLOAD_RTP_DATA_SUCCESS = 'UPLOAD_RTP_DATA_SUCCESS';
export const UPLOAD_RTP_DATA_FAILURE = 'UPLOAD_RTP_DATA_FAILURE';
